module.exports = __webpack_public_path__ + "images/backgrounds/rain/large.9de9b88a694019ab77d1.jpg";